import Helper from './Helper';

class Accordion {
  constructor(config = {}) {
    const {
      accordions,
    } = config;
    this.accordions = Array.prototype.slice.call(document.querySelectorAll(accordions));
    this.currentEl = null;
    if(this.accordions && this.accordions.length !== 0){
      this.checkAnchor();
      this.bindEvents();
    }
  }

  checkAnchor(){
    const currentURL = document.URL;
    const anchor = (currentURL.split('#').length > 1) ? document.URL.split('#')[1] : null;
    if(anchor){
      const anchorElem = document.querySelector('#'+anchor);
      let content;
      let toggle;
      if(Helper.hasClass(anchorElem.parentElement, 'accordion__content')){
        content = anchorElem.parentElement;
        toggle = content.previousElementSibling;
      } else {
        content = anchorElem.nextElementSibling;
        toggle = anchorElem;
      }
      Helper.addClass(toggle, 'active');
      Helper.slideOpen(content, true);
      setTimeout(() =>{
        const hh = document.querySelector('.header').offsetHeight;
        const y = toggle.parentElement.getBoundingClientRect().top + window.scrollY + hh;
        window.scroll({
          top: y,
          behavior: 'smooth'
        });
      }, 300); // 200 is speed of slide open
      this.setAnchorActiveInMenu(toggle);
    }
  }

  setAnchorActiveInMenu(anchor){
    const menuItems = [...document.querySelectorAll(`.main-menu__item--active .main-menu__link[href$="${anchor.id}"]`)];
    if(menuItems.length > 0){
      menuItems.forEach(item => {
        if(anchor.classList.contains('active')){
          item.parentElement.classList.add('main-menu__item--anchor-active');
        } else{
          item.parentElement.classList.remove('main-menu__item--anchor-active');
        }
      });
    }
  }

  bindEvents() {
    this.accordions.forEach(el => {
      el.addEventListener('click', (e) => {
        if(el.classList.contains('active')){
          Helper.slideClose(el.nextElementSibling);
          el.classList.remove('active');
        } else{
          el.classList.add('active');
          Helper.slideOpen(el.nextElementSibling, true);
        }
        this.setAnchorActiveInMenu(el);
      });
    });
  }

}

export default Accordion;
